import $ from 'jquery';
import bodyScrollClass from './bodyScrollClass';
import navigationToggle from './navigationToggle';

const BASE_URL = 'https://www.sailingisland.de/';
const PAGE_URL = 'master-yachtoffice';
const INSERT_CSS_PATHS = ['typo3conf/ext/sailingisland_theme/Resources/Public/CSS/main.css'];
const INSERT_JS_PATHS = ['typo3conf/ext/sailingisland_theme/Resources/Public/JavascriptBuild/build.vendors~main.js', '/typo3conf/ext/sailingisland_theme/Resources/Public/JavascriptBuild/build.main.js'];
const BODY_CLASS = 'yachtoffice';
const MAIN_WRAP_CLASSES = 'page-main page-main--yachtoffice container container--margin flowing-text';
const MAIN_WRAP_CLASSES_2 = 'container__inside--small';
const HOSTNAME = 'www.yachtoffice.de';

let pageData;

function loadPage(cb) {
  $.ajax({
    url: BASE_URL + PAGE_URL,
    success: function(data) {
      pageData = $.parseHTML(data);
      console.log(pageData);
      cb();
    }
  });
}

function insertCss() {
  INSERT_CSS_PATHS.forEach((path) => {
    const css = `<link rel="stylesheet" href="${BASE_URL}${path}">`;
    $('head').append(css);
  });
}

function insertJs() {
  INSERT_JS_PATHS.forEach((path) => {
    const js = `<script src="${BASE_URL}${path}"></script>`;
    $('body').append(js);
  });

  // window.document.dispatchEvent(new Event("DOMContentLoaded", {
  //   bubbles: true,
  // }));
}

function getHTMLElementByNodeName(nodeName) {
  return pageData.map((element) => {
    if (element.nodeName === nodeName) {
      return element;
    }
  });
}

function renderHeader() {
  const header = getHTMLElementByNodeName('HEADER');
  console.log(header);
  $('body').prepend(header);
}

function renderFooter() {
  const footer =  getHTMLElementByNodeName('FOOTER');
  $('body').append(footer);
}

function renderMainWrap() {
  const mainWrap =  getHTMLElementByNodeName('MAIN');
  $('body').wrapInner(`<div class="${MAIN_WRAP_CLASSES}"><div class="${MAIN_WRAP_CLASSES_2}"></div></div>`);
}

function addBodyClass() {
  $('body').addClass(BODY_CLASS);
}

document.addEventListener('DOMContentLoaded', event => {
//  return false;

  if (window.location.hostname !== HOSTNAME) {
    return false;
  }

  loadPage(() => {

    bodyScrollClass();
    addBodyClass();
    renderMainWrap();
    insertCss();
    renderHeader();
    renderFooter();
    insertJs();
    navigationToggle();
  });
});

